import { Term, QuizQuestion } from './types';

export class QuizService {
  private terms: Term[] = [];

  constructor(terms: Term[]) {
    this.terms = terms;
  }

  generateQuiz(): QuizQuestion[] {
    // Shuffle the terms and take 20 random ones
    const shuffledTerms = this.shuffleArray([...this.terms]);
    const selectedTerms = shuffledTerms.slice(0, 20);

    return selectedTerms.map((term, index) => {
      // Get 3 random wrong definitions
      const wrongDefinitions = this.getWrongDefinitions(term.description);
      
      // Combine correct and wrong definitions and shuffle
      const allOptions = [term.description, ...wrongDefinitions];
      const shuffledOptions = this.shuffleArray(allOptions);
      
      // Find the index of the correct answer
      const correctAnswerIndex = shuffledOptions.findIndex(option => option === term.description);

      return {
        id: index + 1,
        term: term.term,
        correctDefinition: term.description,
        options: shuffledOptions,
        correctAnswerIndex
      };
    });
  }

  private getWrongDefinitions(correctDefinition: string): string[] {
    // Get all definitions except the correct one
    const otherDefinitions = this.terms
      .map(t => t.description)
      .filter(def => def !== correctDefinition);
    
    // Shuffle and take 3 random ones
    const shuffled = this.shuffleArray(otherDefinitions);
    return shuffled.slice(0, 3);
  }

  private shuffleArray<T>(array: T[]): T[] {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }
}
